import { render, staticRenderFns } from "./workService.vue?vue&type=template&id=4fc399d4&"
import script from "./workService.vue?vue&type=script&lang=ts&"
export * from "./workService.vue?vue&type=script&lang=ts&"
import style0 from "./workService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports